import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const reasons = ["Fuiste 'la comprensiva' que no reclama. Él aprendió que puede ignorarte sin consecuencias.", 'Te vestiste sexy, le diste lo mejor en la cama. Te volviste una opción cómoda y barata.', "Justificaste sus 'traumas' y 'miedos'. Te convertiste en su terapeuta gratuita.", 'Crees que si aguantas más, cambiará. No. Solo vas a envejecer esperando.'];
export function WhyDidntWork() {
  return <section className="py-16 md:py-24 px-5 bg-[#F2EBE1]" data-id="element-184">
      <div className="max-w-2xl mx-auto" data-id="element-185">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-[#5C1A2B] mb-10 text-center leading-tight" data-id="element-186">
          Ya lo intentaste todo. Nada funcionó.
        </motion.h2>

        <div className="space-y-4" data-id="element-187">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="flex items-start gap-4 bg-[#FAF5EE] p-5 md:p-6 shadow-sm" data-id="element-188">
              <div className="flex-shrink-0 mt-0.5" data-id="element-189">
                <div className="w-7 h-7 rounded-full bg-[#C86B5E]/10 flex items-center justify-center" data-id="element-190">
                  <XIcon className="w-4 h-4 text-[#C86B5E]" data-id="element-191" />
                </div>
              </div>
              <p className="text-base md:text-lg text-[#4A4A4A] font-light leading-relaxed" data-id="element-192">
                {reason}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}